export default {
    location: "仓库",
    marking: "唛头",
    markingList: '唛头清单',
    markings: '个唛头',
    customerMarkings: '客户唛头',

    supplierName: '供应商名称',
    supplierContact: '供应商联络',
    purchaseOrderNo: '采购单号',
    supplierPurchaseNo: "供应商采购单号",
    courierNo: "快递单号",
    handleQty: '产品数量',
    pcsCtn: '每箱件数',
    packUnit: '包装数量',
    cbm: '立方',
    tValue: '总价值',
    tCbm: '总立方',
    tWeight: '总重量',
    code: '编码',

    loaded: '已上柜',
    pending: '未上柜',

    action: `选项`,

    systemId: '系统ID',
    split: '分批货物',
    splitId: `分批Id`,
    yes: '是',
    no: '否',
    isSplit: `分批`,
    notSplit: `原品`,

    delete: "删除"
}